export const environment = {
  API: 'https://api.oracychampions.com/api',
  sentryDSN: 'https://d396ccf94192a08113473e481ff9810d@o23717.ingest.us.sentry.io/4507780889640960',
  openAIAPIKey:
    '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',
};
